module.exports = __webpack_public_path__ + "weathericons-regular-webfont.4618f0de2a818e7ad3fe.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/weather-icons/fonts/weathericons-regular-webfont.ttf
// module id = ../../../../../theme/scss/icons/weather-icons/fonts/weathericons-regular-webfont.ttf
// module chunks = styles